var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "dropdown",
    staticClass: "dropdown-container w-full relative"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('input', {
    class: [_vm.error ? 'border-error bg-red-50 text-red-500 placeholder-red-500' : 'border border-gray-300 text-gray-500 placeholder-gray-400'],
    attrs: {
      "type": "text",
      "placeholder": "Search by Content ID or Title"
    },
    domProps: {
      "value": _vm.displayValue
    },
    on: {
      "input": _vm.onSearch,
      "focus": _vm.openDropdown
    }
  })]), _vm.isOpen ? _c('div', {
    staticClass: "dropdown-list"
  }, _vm._l(_vm.filteredItems, function (item) {
    return _c('label', {
      key: item.id,
      staticClass: "dropdown-item justify-start items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedId,
        expression: "selectedId"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.selectedId, item.id)
      },
      on: {
        "change": [function ($event) {
          _vm.selectedId = item.id;
        }, function ($event) {
          return _vm.selectItem(item);
        }]
      }
    }), _c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-name"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c('div', {
      staticClass: "item-id"
    }, [_vm._v(" ID: " + _vm._s(item.id) + " ")])])]);
  }), 0) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }